export const iconFontAwesomeHumanitarianWorm = (
	<i className="fa-solid fa-worm"></i>
);
